
import { Component, OnInit, Inject } from '@angular/core';
import { DOCUMENT, ViewportScroller } from '@angular/common';
import { Observable, fromEvent } from 'rxjs';
import * as $ from 'jquery';

@Component({
  selector: 'app-who-we-are',
  templateUrl: './who-we-are.component.html',

})
/** who-we-are component*/
export class WhoWeAreComponent implements OnInit {
  scrollTimer: any;
  
  private documentDone: Observable<any>

  constructor(@Inject(DOCUMENT) private document: any) {

  }

  ngOnInit() {
    console.clear();
    console.log('init called!!');
    try {
      this.documentDone = fromEvent(this.document, 'readystatechange');
      this.documentDone.subscribe(state => this.scrollToContent());
    } catch (e) {
      console.error(e.message);
    }
    

  }

  startScroll(speed, control) {
    if (this.scrollTimer) {
      clearInterval(this.scrollTimer);
    }
    this.scrollTimer = setInterval(() => {
      $(control).scrollLeft($(control).scrollLeft() + speed);
    }, 10);

  }

  stopScroll() {
    if (this.scrollTimer) {
      clearInterval(this.scrollTimer);
    }
  }

  toggleActive(e, parentContainer) {
    
    $(parentContainer + " .navButton").removeClass("active");
    e.srcElement.className = "navButton active";
  }

  scrollToContent() {
    console.log('Scrolling!!')
    if (location.hash) {
      setTimeout(function () {
        console.log("Scroll to:" + location.hash);
        const scrollTo = $(location.hash).offset().top-100;
        console.log("offset: " + scrollTo);
        $('html, body').stop().animate({ scrollTop: scrollTo }, 500);
      }, 500);
    }
  }

}
